// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import VueFire from 'vuefire';
import firebase from 'firebase/app';
import 'firebase/firestore';

Vue.config.productionTip = false;

Vue.use(VueFire);
firebase.initializeApp({
  apiKey: "AIzaSyBA3QussrfFSTzGbevqfciX7fiapa64iXk",
  authDomain: "fdlivestream.firebaseapp.com",
  databaseURL: "https://fdlivestream.firebaseio.com",
  projectId: "fdlivestream",
  storageBucket: "fdlivestream.appspot.com",
  messagingSenderId: "224162123239"
});

var firestore = firebase.firestore();
export const db = firestore;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});


// WEBPACK FOOTER //
// ./src/main.js